import { dom } from "vnet-dom";




export const onLoadModa = () => {
  dom.window.addEventListener('DOMContentLoaded', e => {
    $.fancybox.open($('.js-alert-on-load'), { touch: false });
  });
}